<ion-row class="p-0 headerBreadcrumb">
  <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0">
    <div class="d-flex pt-5 pb-10 pr-10 pl-0">
      <img src="././assets/icon/backArrow.svg" class="cp" (click)="backbtn()">
      <label class="font_semibold fs-18 ml-10 mt-5 black_color">
        <span class="cp" (click)="backbtnToListingpage()">{{auditLogModuleName}}</span>&nbsp;>&nbsp;
        <span class="cp" (click)="backbtn()">{{auditLogNumber}}</span>&nbsp;>&nbsp;
        <span [style.color]="subModuleButtonColor">Logs</span></label>
    </div>
  </ion-col>
</ion-row>
<div class="table-layout">
  <ion-grid class="p-0">
    <div class="tableBox mt-10">
      <ion-row class="p-0">
        <table class="hover">
          <thead class="bg-gray">
            <tr>
              <th class="fs-14 font_bold cl-black" *ngFor="let item of gridData.columnInfo">
                <div class="verticle-center icon-style">{{item.label}}
                  <div class="d-flex flex-column ml-10" *ngIf="item.label != 'Action'">
                    <i class="material-icons cp" *ngIf="item.propertyName != 'sNo'"
                      (click)="sortAsending(item.sortingName)">arrow_drop_up</i>
                    <i class="material-icons cp" *ngIf="item.propertyName != 'sNo'"
                      (click)="sortDesending(item.sortingName)">arrow_drop_down</i>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody class="bg-white" *ngIf="renderData.length !== 0">
            <tr *ngFor="let item of renderData;let i=index">
              <ng-container *ngFor="let innerItem of item">
                <td *ngIf="innerItem.key !== 'id'" class="fs-16 font_regular">
                  <span>{{innerItem.value}}</span>
                  <a *ngIf="innerItem.value == 'uploadingTheContract' &&
                  (innerItem.key== 'oldValue' || innerItem.key == 'newValue')" [href]="innerItem.value" target="_blank">Contract</a>
                </td>
              </ng-container>
            </tr>
          </tbody>
        </table>
        <!-- <ion-row class="mt-5 mb-5" *ngIf="renderData.length != 0">
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="center-content">
            <ion-label class="fs-14 font_bold black_color">Showing {{showingCount}} to {{showingOfCount}} of
              {{gridData.totalCount}} entries</ion-label>
          </ion-col>
        </ion-row> -->
      </ion-row>
      <!-- <ion-row class="bg-white display-center" *ngIf="renderData.length === 0">
        <div class="pt-50 pb-40 fs-16 font_medium cl-black">No Data Available</div>
      </ion-row> -->
    </div>
    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="display-end">
      <ul class="dt_pagination">
        <ion-row class="float-right pgintn">
          <li class="fs-16">{{currentPage}}</li>
          <span class="fs-14 font_regular p-10">of {{gridData.totalNoOfPages}}</span>
          <li class="fs-24 cp" (click)="previousPage()" [ngClass]="{'disableBtn': currentPage==1}">&lt;</li>
          <li class="fs-24 cp" (click)="nextPage()" [ngClass]="{'disableBtn': currentPage== gridData.totalNoOfPages}">
            &gt;</li>
        </ion-row>
      </ul>
    </ion-col>
    <div class="clear100"></div>
    <div class="clear20"></div>
  </ion-grid>
</div>
